import { Button } from "antd";
import {
    CheckCircleFilled
} from "@ant-design/icons";
import { useState } from "react";
import { useTranslation } from "react-i18next";

type PageType = {
    id: string;
    name: string;
    username: string;
    img: string;
};

const pages: PageType[] = [
    {
        id: "1",
        name: "Buso - Thiết kế Website",
        username: "busothietkeweb",
        img: "https://pancake.vn/static/images/platform-connection/facebook.png",
    },
    {
        id: "2",
        name: "Marketing Online",
        username: "marketingonline",
        img: "https://pancake.vn/static/images/platform-connection/facebook.png",
    },
];

type Props = {
    open: boolean;
    onClose: () => void;
};

type SidebarItem = {
    key: string;
    label: string;
    icon?: string;
    count?: number;
};

export default function PendingView() {
    const { t } = useTranslation();
    const [selectedIds, setSelectedIds] = useState<string[]>([]);

    const toggleSelect = (id: string) => {
        setSelectedIds((prev) =>
            prev.includes(id)
                ? prev.filter((item) => item !== id)
                : [...prev, id]
        );
    };

    return (
        <>
            {/* LIST GRID */}
            <div className="flex-1 overflow-y-auto">
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-8">
                    {pages.map((page) => {
                        const isSelected = selectedIds.includes(page.id);

                        return (
                            <div
                                key={page.id}
                                onClick={() => toggleSelect(page.id)}
                                className={`
                                    relative border rounded-xl p-4 cursor-pointer
                                    transition-all duration-200
                                    ${isSelected
                                        ? "bg-yellow-50 border-yellow-400 shadow-sm"
                                        : "bg-white hover:shadow hover:border-gray-300"
                                    }
                                `}
                            >
                                {/* CHECK ICON */}
                                {isSelected && (
                                    <CheckCircleFilled
                                        className="absolute top-3 right-3 text-[#3e91ab] text-lg"
                                    />
                                )}

                                <div className="flex items-center gap-3">
                                    <div className="w-12 h-12 bg-gray-200 rounded-full">
                                        <img
                                            src={page.img}
                                            alt={page.name}
                                            className="w-full h-full object-cover rounded-full"
                                        />
                                    </div>

                                    <div>
                                        <div className="font-medium text-gray-800">
                                            {page.name}
                                        </div>
                                        <div className="flex gap-1 items-center text-sm text-gray-500">
                                            <div className="w-[14px] h-[14px] bg-gray-200 rounded-full">
                                                <img
                                                    src={page.img}
                                                    alt={page.name}
                                                    className="w-full h-full object-cover rounded-full"
                                                />
                                            </div>
                                            <div className="text-sm text-gray-500">
                                                @{page.username}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        );
                    })}
                </div>
            </div>

            {/* FOOTER BUTTON */}
            <div className="flex justify-end pt-4 border-t">
                <Button
                    type="primary"
                    disabled={selectedIds.length === 0}
                >
                    {t('chats.activate')}
                </Button>
            </div>
        </>
    );
}